import React from "react";
import { AlertCircle } from "lucide-react";
import { motion } from "framer-motion";

const EmergencyButton = ({ onClick }) => {
  return (
    <motion.button
      onClick={onClick}
      className="fixed bottom-8 right-8 z-50 bg-red-600 hover:bg-red-700 text-white rounded-full 
  shadow-2xl p-4 flex items-center gap-3 group transition-all duration-300 hover:scale-105"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
        delay: 0.5,
      }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* Pulsing effect */}
      <span className="absolute inset-0 rounded-full bg-red-600 animate-ping opacity-30"></span>

      <div className="relative flex items-center gap-3">
        <AlertCircle className="w-6 h-6" />
        <span className="font-semibold text-lg hidden sm:block">
          Emergency Help
        </span>
      </div>
    </motion.button>
  );
};

export default EmergencyButton;
